import { ProFormSelect, RequestOptionsType } from '@ant-design/pro-components';
import { DatePicker, Form, Input, InputNumber, Space, message } from 'antd';
import { useWatch } from 'antd/es/form/Form';
import { ROUTES } from 'base/routes/routes';
import BoxContainer from 'base/ui/components/BoxContainer';
import CustomButton from "base/ui/components/Button";
import CustomSelect from 'base/ui/components/CustomSelect';
import { Download } from 'base/ui/components/Icons';
import dayjs from 'dayjs';
import useDebounce from 'hooks/useDebounce';
import { cloneDeep } from 'lodash';
import { observer } from 'mobx-react';
import { getDropdownCatalog } from 'pages/Common/dropdown';
import PageWrapper from 'pages/Components/PageWrapper';
import { SearchForm, SearchItem } from 'pages/Components/SearchBox';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { CommonModel } from 'services/Main/common_services';
import { commonPresenter, commonStore, exchangeRewardsPresenter, exchangeRewardsStore } from 'stores/root_store';
import { DATE_FORMAT_POST, SYSTEM_TITLE } from 'utils/constants';
import { useCheckPermission } from 'utils/permissionHelper';
import { customFilterOption } from 'utils/searchHelper';

const { RangePicker } = DatePicker

// THÊM MỚI DANH SÁCH QUÀ TẶNG / CHỈNH SỬA DANH SÁCH QUÀ TẶNG
const createUpdateGiftPage = () => {
  return observer(() => {
    //=====================================CHUYỂN NGÔN NGỮ=====================================//
    const { t } = useTranslation();
    const { id } = useParams();

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    // lưu / lưu và tiếp tục
    const [isContinue, setContinue] = useState(false);


    // danh sách đơn vị
    const [measurementUnit, setMeasurementUnit] = useState<CommonModel[]>([])
    const [dropdownObjectApply, setDropdownObjectApply] = useState<CommonModel[]>([])
    const [dropdownConversionMethod, setDropdownConversionMethod] = useState<CommonModel[]>([])
    const [membershipLevel, setMembershipLevel] = useState<CommonModel[]>([])

    const [programList, setProgramList] = useState<CommonModel[]>([])

    const [form] = Form.useForm();
    let pageTitle = "";

    // Nếu có id là chỉnh sửa (xem chi tiết)
    if (id) {
      // Kiểm tra phân quyền
      useCheckPermission("EDIT");
      pageTitle = 'Chỉnh sửa';
      document.title = pageTitle + " - " + SYSTEM_TITLE;
    } else {
      // Kiểm tra phân quyền
      useCheckPermission("CREATE");
      pageTitle = 'Thêm mới';
      document.title = pageTitle + " - " + SYSTEM_TITLE;
    }

    const layoutSpan = {
      labelCol: { span: 6 },
      wrapperCol: { span: 18 }
    }

    const conversionForm = useWatch('conversionForm', form)

    const handleGetDetail = async () => {
      if (id) {
        await exchangeRewardsPresenter.detailGift(exchangeRewardsStore, id);
        if (exchangeRewardsStore.detailRes.isSuccess) {
          const data = cloneDeep(exchangeRewardsStore.detailRes.data);
          form.setFieldsValue({
            ...data,
            expiryDate: [data!.expiryDateFrom && dayjs(data!.expiryDateFrom), data!.expiryDateTo && dayjs(data!.expiryDateTo)]
          });
        } else {
          message.error(exchangeRewardsStore.detailRes.message);
        }
      }
    }

    const getListProgram = async (key?: string) => {
      await commonPresenter.getListProgram(commonStore, key)
      if (commonStore.commonRespone.isSuccess) {
        setProgramList(commonStore.commonRespone.data)
      }
    }
    const debounceListProgram = useDebounce(getListProgram, 500)

    useEffect(() => {
      getDropdownCatalog({ onSetDropdown: setDropdownObjectApply, params: { catalogTypeCode: 'ApplicableTarget' } })
      // getDropdownCatalog({ onSetDropdown: setDropdownConversionMethod, params: { catalogTypeCode: 'ConversionMethod' } })
      getDropdownCatalog({ onSetDropdown: setMembershipLevel, params: { catalogTypeCode: 'MembershipLevel' } })
      getDropdownCatalog({ onSetDropdown: setMeasurementUnit, params: { catalogTypeCode: 'MeasurementUnit' } })
      handleGetDetail()
      debounceListProgram()
    }, [])

    return (
      <PageWrapper
        breadcrumb={[
          {
            text: 'Danh sách quà tặng',
            to: ROUTES.EXCHANGE_REWARDS.GIFTS.LINK,
          },
          {
            text: pageTitle,
          },
        ]}
        extras={
          <>
            <CustomButton
              loading={loading}
              onClick={(e) => {
                form.submit();
                setContinue(false);
              }}
              type="default"
              icon={<Download className="!fill-black" />}
            >
              {t("btn.save")}
            </CustomButton>
            <CustomButton
              loading={loading}
              onClick={() => {
                form.submit();
                setContinue(true);
              }}
              type="primary"
              icon={<Download className="!fill-white" />}
            >
              Lưu và tiếp tục
            </CustomButton>
          </>
        }
      >
        {/* Table */}
        <BoxContainer fullHeight>
          <SearchForm
            form={form}
            {...layoutSpan}
            layout="horizontal"
            labelAlign="right"
            onFinish={async (fieldsValue) => {
              setLoading(true);
              const dataSave = cloneDeep(fieldsValue)
              Object.assign(dataSave, {
                expiryDateFrom: dataSave.expiryDate?.[0] && dayjs(dataSave.expiryDate?.[0]).format(DATE_FORMAT_POST),
                expiryDateTo: dataSave.expiryDate?.[1] && dayjs(dataSave.expiryDate?.[1]).format(DATE_FORMAT_POST),
              })


              const result = id ?
                await exchangeRewardsPresenter.createGift(exchangeRewardsStore, { ...dataSave, id: id })
                : await exchangeRewardsPresenter.createGift(exchangeRewardsStore, dataSave)

              setLoading(false);
              if (result.isSuccess) {
                message.success(result.message);
                if (isContinue) {
                  // Nếu đang chỉnh sửa thì không làm gì
                  if (!id) form.resetFields();
                } else {
                  navigate(ROUTES.EXCHANGE_REWARDS.BASE);
                }
              } else {
                // message.error(result.message);
              }


            }}
            column='col-2'
          >
            {/* đối tượng áp dụng */}
            <SearchItem label="Đối tượng áp dụng" name={'applicableObject'} >
              <CustomSelect
                options={dropdownObjectApply.map((item) => ({
                  label: `${item.key} | ${item.value}`,
                  value: item.key,
                }))}
                filterOption={customFilterOption} />
            </SearchItem>
            {/* Chương trình */}
            <SearchItem label="Chương trình" name={'programId'} >
              <CustomSelect
                options={programList.map((item) => ({
                  label: `${item.value}`,
                  value: item.key,
                }))}
                onClear={() => debounceListProgram()}
                showSearch
                allowClear
                onSearch={(value) => value ? debounceListProgram(value) : debounceListProgram()}
                filterOption={false} />
            </SearchItem>

            {/* Mức doanh số tích lũy */}
            <SearchItem
              start
              label={'Mức doanh số tích lũy'}
            >
              <div className='!flex !w-full [&_.green]:!w-full'>
                <SearchItem name={'revenueLevelFrom'}>
                  <InputNumber className='!w-full' min={0} formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    style={{ width: '100%', textAlign: 'right' }} placeholder="Từ" />
                </SearchItem>
                <Input
                  className="site-input-split"
                  style={{
                    width: 30,
                    borderLeft: 0,
                    borderRight: 0,
                    pointerEvents: 'none',
                  }}
                  placeholder="~"
                  disabled
                />
                <SearchItem name={'revenueLevelTo'}>
                  <InputNumber min={0} formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    className="site-input-right !w-full"
                    style={{ width: '100%', textAlign: 'right' }} placeholder="Đến"
                  />
                </SearchItem>
              </div>
            </SearchItem>

            {/* hạng thành viên */}
            <SearchItem label="Hạng thành viên" name={'membershipRank'} >
              <CustomSelect
                options={membershipLevel.map((item) => ({
                  label: `${item.key} | ${item.value}`,
                  value: item.key,
                }))}
                showSearch
                allowClear
                filterOption={customFilterOption} />
            </SearchItem>
            {/* Hình thức quy đổi */}
            <ProFormSelect
              showSearch
              fieldProps={{
                filterOption: customFilterOption,
                onChange: (value, option) => {
                  if (value === 'HTQD1') {
                    form.setFieldValue('unit', 'DVT1')
                  } else if (value === 'HTQD2') {
                    form.setFieldValue('unit', 'DVT2')
                  }
                }
              }}
              label={<strong>Hình thức quy đổi</strong>}
              name={'conversionForm'}
              request={async ({ keyWords }, props) => {
                await getDropdownCatalog({ onSetDropdown: setDropdownConversionMethod, params: { catalogTypeCode: 'ConversionMethod' } })
                const result = commonStore.commonRespone.data?.map((item) => ({
                  label: `${item?.value}`,
                  value: item?.key,
                })) as RequestOptionsType[]
                return result || []
              }}
            />

            {/* đơn vị */}
            <SearchItem label="Đơn vị" name={'unit'} >
              <CustomSelect
                options={measurementUnit.map((item) => ({
                  label: `${item.key} | ${item.value}`,
                  value: item.key,
                }))}
                allowClear
                disabled
                filterOption={customFilterOption} />
            </SearchItem>
            {/* giá trị quà tặng */}
            <SearchItem label="Giá trị quà tặng" name={'giftValue'} >
              <InputNumber
                min={0} max={conversionForm === 'HTQD1' ? 100 : undefined} formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                style={{ width: '100%', textAlign: 'right' }}
              />
            </SearchItem>
            {/* thời hạn sử dụng */}
            <SearchItem label="Thời hạn" name={'expiryDate'} >
              <RangePicker allowEmpty={[true, true]} className='w-full' format="DD/MM/YYYY" />
            </SearchItem>

          </SearchForm>

        </BoxContainer>

      </PageWrapper>
    )
  })
}

export default createUpdateGiftPage